import { Box, Typography } from '@mui/material'

const TitleWithInfo = ({
  title, info, customStyle,
}) => (
  <Box sx={[styles.root, customStyle]}>
    <Typography variant="h5" sx={styles.titleStyle}>
      {title}
    </Typography>
    <Typography variant="h6" sx={[styles.infoStyle]}>
      {info || '-- -- --' }
    </Typography>
  </Box>
)

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '15px',
  },
  titleStyle: {
    fontSize: '18px',
    textTransform: 'capitalize',
  },
  infoStyle: {
    fontSize: '18px',
    textTransform: 'capitalize',
    textAlign: 'end',
  },
}
export default TitleWithInfo
